import React, { Component } from "react";
import { Link } from 'react-router-dom';
import styled from "styled-components";
import { Grid, Row, Col } from 'react-flexbox-grid';

const Wrapper = styled.header`
  background: #333333;
  padding-left: 15px;
  padding-top: 5px;
  padding-bottom: 10px;
  
  h1 {
    text-align: left;
    color: #fff;  
    font-size: 1.625em;
    font-weight: 700;
  }
  
  h1 a {
    color: #fff;
    text-decoration: none;
  }
`;

class Header extends Component {
  render() {
    return (
      <Wrapper>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <h1><Link to="/">Blockscale</Link></h1>
            </Col>
          </Row>
        </Grid>
      </Wrapper>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/App/Header/index.js